import { Base } from "../../framework/base";
import { ITaskDataRowCol, TaskDataRowCol } from "./taskDataRowCol";

export interface ITaskDataRowDefaultValues {
    cols: ITaskDataRowCol[];
}

export class TaskDataRowDefaultValues implements ITaskDataRowDefaultValues {
    cols: TaskDataRowCol[];

    constructor();
    constructor(obj: ITaskDataRowDefaultValues);
    constructor(obj?: any) {
        this.cols = Base.getTypedArray<TaskDataRowCol>(obj ? obj.cols : null, TaskDataRowCol);
    }
}